export default [
    {
        key: 'cash',
        title: 'Cash on delivery',
        description: 'Pay with cash upon delivery.',
    },
];
